export const upperCaseFirstLetter = (item: string) => {
  return item
    ? item.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase())
    : "";
};

/** Tamanho de arquivo legível. KB/MB com uma casa — o byte cru não diz nada a quem lê. */
export const tamanhoLegivel = (bytes: number): string => {
  if (!Number.isFinite(bytes) || bytes <= 0) return "0 KB";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
};
